var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._g(_vm._b({ref:"input"},'v-autocomplete',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }